<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1 class="m-0">Clientes</h1>
                </div><!-- /.col -->
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">
                                Home
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">Clientes</li>
                    </ol>
                </div><!-- /.col -->
            </div><!-- /.row -->
        </div><!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="d-flex justify-content-between">
                                <h3 class="card-title">Lista de Clientes</h3>
                                <PrimaryButton class="btn btn-primary" @click="updateClientsList">
                                    {{ $getLocaleMessage('buttons', 'update') }} lista de Clientes
                                </PrimaryButton>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="d-flex">
                                <input type="text" class="form-control" placeholder="Buscar Cliente..."
                                    v-model="searchStringModel" />
                            </div>
                            <!-- /.d-flex -->

                            <div class="position-relative col-sm-12">
                                <ClientsTable :list="paginatedClients" @sort="sortBy($event)" @edit="openEditionForm" />
                                <Pagination v-if="filteredS.length > itemsPerPage" :list="filteredS"
                                    :items-per-page="itemsPerPage" :current-page="currentPage"
                                    @current-page="setCurrentPage($event)" />

                                <Modal>
                                    <EditForm v-if="modalContent == 1 && editing == true" :client="selectedClient"
                                        :temp-values="tempValues" @show-table="showTable($event)"
                                        @close-modal="modalStatus" @change-modal-content="modalContent = $event">
                                    </EditForm>

                                </Modal>
                            </div>
                        </div>
                    </div>
                    <!-- /.card -->
                </div>
            </div>
            <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
</template>

<script>
import PrimaryButton from '@/Components/PrimaryButton.vue';
import ClientsTable from '@/Components/Tables/ClientsTable.vue';
import Pagination from '@/Components/Bootstrap/Pagination.vue';
import Modal from '@/Components/Bootstrap/Modal.vue';
import EditForm from '@/Components/Forms/Clients/Edit.vue';

import { mapState, mapActions, mapGetters } from 'pinia';
import { useClientsStore } from '@/pinia/clients.module';
import { useStatusStore } from '@/pinia/status.module';

export default {
    components: {
        PrimaryButton,
        ClientsTable,
        Pagination,
        Modal,
        EditForm
    },
    data() {
        return {
            modalContent: 0,
            editing: false,
            selectedClient: {},
            tempValues: {}
        }
    },
    computed: {
        ...mapState(useClientsStore, ['itemsPerPage', 'currentPage', 'searchString']),
        ...mapGetters(useClientsStore, ['paginatedS', 'filteredS']),
        paginatedClients() {
            return this.paginatedS;
        },
        searchStringModel: {
            get() {
                return this.$pinia.state.value.clients?.searchString || '';
            },
            set(value) {
                this.setSearchString(value);
            }
        }
    },
    methods: {
        ...mapActions(useClientsStore, [
            'fetchClients',
            'sortBy',
            'filteredS',
            'setCurrentPage',
            'setSearchString',
            'updateClientsList'
        ]),
        ...mapActions(useStatusStore, ['fetchStatus']),
        openEditionForm(client) {
            this.selectedClient = client;
            this.modalContent = 1;
            this.editing = true;
        }, showTable(data) {
            this.tempValues = data;
            this.modalContent = data.contentNumber;
        },
        modalStatus(status) {
            if (status) {
                $('#modal-lg').modal('hide');
            }
        }
    },
    mounted() {
        // Limpiar el estado cuando se cierra la modal
        $('#modal-lg').on('hidden.bs.modal', () => {
            this.modalContent = 0;
            this.editing = false;
            this.selectedClient = {};
            this.tempValues = {};
        });

        this.fetchClients();
    },
    created() {
        this.fetchClients();
        this.fetchStatus();
    },
}
</script>